import React, { useState } from "react";
import {
    required,
    Edit,
    Create,
    TextField,
    EditButton,
    CloneButton,
    SimpleForm,
    TextInput,
    ReferenceArrayInput,
    SelectArrayInput,
    ArrayField,
    SingleFieldList,
    ChipField,
    Labeled,
    useNotify,
} from "react-admin";
import PrevPagination from "../core/PrevPagination";
/*
    To configure pagination - we should have a look at this
    https://github.com/marmelab/react-admin/blob/master/docs/List.md#pagination
*/
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";
import BulkEditButton from "../core/BulkEditButton";
import ClientChartBulkEdit from "../custom/editors/ClientChartBulkEdit";
import BulkActionList from "../custom/BulkActionList";

const ClientChartBulkActionList = ({ onBulkEdit, ...props }) => (
    <BulkActionList
        resource="portal/clientCharts"
        perPage={10}
        sort={{ field: "name", order: "ASC" }}
        pagination={<PrevPagination />}
        fields={[
            { type: TextField, props: { source: "id" } },
            { type: TextField, props: { source: "name" } },
            { type: EditButton, props: {} },
            { type: CloneButton, props: {} },
        ]}
        bulkActionButtons={<BulkEditButton onClick={(selectedIds) => onBulkEdit(selectedIds)} />}
        {...props}
    />
);

export const ClientChartList = (props) => {
    const notify = useNotify();

    const [bulkEditing, setBulkEditing] = useState(false);
    const [selectedChartIds, setSelectedChartIds] = useState([]);

    return (
        (bulkEditing && (
            <ClientChartBulkEdit
                selectedChartIds={selectedChartIds}
                onCancel={() => setBulkEditing(false)}
                onSuccess={() => {
                    setBulkEditing(false);
                    notify("Elements updated");
                }}
                onError={() => {
                    setBulkEditing(false);
                    notify("Elements failed to update", { type: "error" });
                }}
            />
        )) ||
        (!bulkEditing && (
            <ClientChartBulkActionList
                onBulkEdit={(selectedChartIds) => {
                    setSelectedChartIds(selectedChartIds);
                    setBulkEditing(true);
                }}
                {...props}
            />
        ))
    );
};

const ChartTitle = ({ record }) => {
    return <span>Chart {record ? `"${record.name}"` : ""}</span>;
};

const formatSeriesName = (s) => {
    return s && `${s.Subchart.name}: ${s.name != null ? s.name : s.alias && s.alias} [${s.id}]`;
};

export class ClientChartEdit extends React.Component {
    state = {
        errorMessage: null,
    };

    onError(data) {
        this.setState({ errorMessage: data });
    }

    render() {
        return (
            <Edit title={<ChartTitle />} {...this.props}>
                <SimpleForm toolbar={<LVEditToolbar deleteButton={false} />}>
                    <TextInput source="name" validate={[required()]} />
                    <TextInput disabled source="id" label="Chart Id" />

                    <ReferenceArrayInput
                        reference="portal/chartSeries"
                        source="seriesIds"
                        perPage={100}
                        sort={{ field: "Subchart.order", order: "ASC" }}
                        style={{ width: "100%" }}
                    >
                        <SelectArrayInput label="Series" optionText={formatSeriesName} optionValue="id" />
                    </ReferenceArrayInput>

                    <Labeled label="Sites">
                        <ArrayField source="Sites">
                            <SingleFieldList linkType={false}>
                                <ChipField source="shortName" />
                            </SingleFieldList>
                        </ArrayField>
                    </Labeled>
                    <Labeled label="Lines">
                        <ArrayField source="Lines" label="Lines">
                            <SingleFieldList linkType={false}>
                                <ChipField source="lineName" />
                            </SingleFieldList>
                        </ArrayField>
                    </Labeled>

                    {this.state.errorMessage}
                </SimpleForm>
            </Edit>
        );
    }
}

export const ClientChartCreate = (props) => (
    <Create {...props}>
        <SimpleForm toolbar={<LVCreateToolbar {...props} />}>
            <TextInput source="name" validate={[required()]} />

            <ReferenceArrayInput
                label="Series"
                reference="portal/chartSeries"
                source="Series"
                format={(series) => {
                    return series && series.map((s) => s.id);
                }}
                parse={(series) => series.map((s) => ({ id: s }))}
                sort={{ field: "Subchart.subchart_order", order: "ASC" }}
                style={{ width: "100%" }}
            >
                <SelectArrayInput optionText={formatSeriesName} />
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);
